
ul{
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  .wrap{
    position: relative;
    width: 1200px;
    height: 120px;
    margin: 0 auto;
  }
  .list{
    position: relative;
    width: 100%;
    height: 100%;
  }
  .list .item{
    // position: absolute;
    top: 0px;
    width: 33.33%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
  }
  .list .item.active{
    z-index: 10;
  }
  .list .item img{
    width: 100%;
  }
  .wrap .btn{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 100px;
    background: rgba(0,0,0,.5);
    color: #fff;
    border: none;
    cursor: pointer;
    transition: all .3s;
    z-index: 20;
  }
  .wrap .btn:hover{
    background: rgba(0,0,0,.8);
  }
  .wrap .btn.left{
    left: 0px;
  }
  .wrap .btn.rigth{
    right: 0px;
  }